import { NavLink, Outlet } from 'react-router-dom'

const HelpLayout = () => {
  return (
    <div className='help-layout'>
        <h2>Jobrouter Help</h2>

        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, ratione?</p>

        <nav>
            <NavLink to="faq">View the FAQ </NavLink>
            <NavLink to="contact">Contact Us</NavLink>
        </nav>

        <Outlet />
    </div>
  )
}

export default HelpLayout